export default __webpack_public_path__ + "static/media/Measure_Blue.04044e49.webp";